import type { CutSaveState } from '../doc/useCutAutosave';
import { editorMessages } from '../messages/editorMessages';

/** The words of each save state: the top bar, and the line of an action that needs a saved cut. */
export const SAVE_STATE_MESSAGES = {
  saved: editorMessages.saveSaved,
  dirty: editorMessages.saveDirty,
  saving: editorMessages.saveSaving,
  failed: editorMessages.saveFailed,
  invalid: editorMessages.saveInvalid,
  stale: editorMessages.saveStale,
  working: editorMessages.saveWorking,
} as const satisfies Record<CutSaveState, unknown>;
